import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNote = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 4.75C0 3.7835 0.783502 3 1.75 3H22.25C23.2165 3 24 3.7835 24 4.75V19.25C24 20.2165 23.2165 21 22.25 21H1.75C0.783502 21 0 20.2165 0 19.25V4.75ZM1.75 4.5C1.61193 4.5 1.5 4.61193 1.5 4.75V19.25C1.5 19.3881 1.61193 19.5 1.75 19.5H22.25C22.3881 19.5 22.5 19.3881 22.5 19.25V4.75C22.5 4.61193 22.3881 4.5 22.25 4.5H1.75Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5 8.75C5 8.33579 5.33579 8 5.75 8H17.25C17.6642 8 18 8.33579 18 8.75C18 9.16421 17.6642 9.5 17.25 9.5H5.75C5.33579 9.5 5 9.16421 5 8.75Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5 12.75C5 12.3358 5.33579 12 5.75 12H11.25C11.6642 12 12 12.3358 12 12.75C12 13.1642 11.6642 13.5 11.25 13.5H5.75C5.33579 13.5 5 13.1642 5 12.75Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgNote;
